import doMetric from '../../../tracking/bigQueryMetricRecorder';
import Track from '../../../utils/tracking';
import {stopOrderProcessing} from '../../site-actions';
import {setKlarnaError} from './klarna-actions';

export default (errorID, errorBody) => (dispatch, getState) => {
  Track.track(errorBody);
  
  try {
    doMetric('klarnaError', [], [{type: 'errorID', label: errorID}], 'impression');
  } catch (error) {
    Track.track(error);
  }
  
  if (getState()?.site?.orderIsProcessing) {
    dispatch(stopOrderProcessing());
  }
  return dispatch(setKlarnaError(errorID));
};
